import React, { useState, useEffect } from "react";
import "./CSS/Feedback.css";
import pooja from "./IMAGES/woman in black and white striped shirt.png"
import mitali from "./IMAGES/woman in white and blue checked dress shirt.png"
import neha from "./IMAGES/a young man smiling in front of a white backdrop.png"
import Kavita from "./IMAGES/woman in black and white striped shirt (1).png"
import Deepali from "./IMAGES/woman in white and blue checked dress shirt (1).png"
import shruti from "./IMAGES/a young man smiling in front of a white backdrop (1).png"



const feedbackSets = [
    [
  {
    name: "Pooja Patil",
    city: "Delhi",
    img: pooja,
    text: "The Paithani saree I ordered was absolutely stunning. The zari work and traditional motifs were beautifully woven.",
  },
  {
    name: "Mitali Patil",
    city: "Pune",
    img: mitali,
    text: "I bought a festive outfit for my daughter from the kids collection and the fabric was so soft and comfortable. She could enjoy the function without feeling uncomfortable.",
  },
  {
    name: "Neha Kapoor",
    city: "Ahmedabad",
    img: neha,
    text: "I ordered a designer blouse and was surprised by how well it fit. The finishing and embroidery were flawless. It elevated my entire saree look.",
  },
  ],
   [
    {
      name: "Kavita Joshi",
      city: "Jaipur",
      img: Kavita,
      text: "I ordered a handwoven saree for a festive occasion and I could instantly feel the quality the moment I touched it. The fabric was soft yet rich.",
    },
    {
      name: "Deepali Rao",
      city: "Indore",
      img: Deepali,
      text: "I bought a saree and a matching blouse from this website, and both were perfectly coordinated. The blouse fitting was excellent and the saree drape was graceful.",
    },
    {
      name: "Shruti Verma",
      city: "Hyderabad",
      img: shruti,
      text: "I've long sought clothing that embodies contemporary sophistication without unnecessary embellishment",
    },
  ]
];

export default function Feedback() {
    const [index, setIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setIndex((prev) => (prev + 1) % feedbackSets.length);
  }, 5000); // 5 seconds

  return () => clearInterval(interval);
}, []);
  return (
    <section className="feedback">
      <div className="feedback-header">
        <div>
        <h1>Feedback We Cherish</h1>
    <p>Words of love from the women who wear our creations.</p>

        
      </div>
              {/* <span className="see-all">See all</span> */}
</div>


     <div className="feedback-container">
  {feedbackSets[index].map((item, i) => (
    <div className="feedback-card" key={i}>
            
            <div className="top">
             <div className="polaroid">
  <img src={item.img} alt={item.name} />
  <span>{item.name}</span>
</div>

              <div className="city">{item.city}</div>
            </div>

           <div className="hearts">
  {[...Array(5)].map((_, i) => (
    <svg
      key={i}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="#FF5A00"
    >
      <path d="M8.75 14.375C8.75 14.375 0.625 10 0.625 4.84417C0.625 2.51417 2.51417 0.625 4.84417 0.625C6.60833 0.625 8.12 1.58667 8.75 3.125C9.38 1.58667 10.8917 0.625 12.6567 0.625C14.9858 0.625 16.875 2.51417 16.875 4.84417C16.875 10 8.75 14.375 8.75 14.375Z" />
    </svg>
  ))}
</div>

            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}